import { render, staticRenderFns } from "./CreateRoom.vue?vue&type=template&id=45bb44f4&scoped=true&"
import script from "./CreateRoom.vue?vue&type=script&lang=js&"
export * from "./CreateRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb44f4",
  null
  
)

export default component.exports